import { render } from "./CIS-Resource-Press-Release.vue?vue&type=template&id=e0f6d3de"
import script from "./CIS-Resource-Press-Release.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Press-Release.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__